import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { DataTable, DateTime, Price, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { usePaymentDetailsFormSlots } from '../../../slots/PaymentDetailsFormSlotsContext.js';

/*
 * We can assume that `installments` is already sorted in the backend by date from old to new
 * i.e. [yesterday, today, tomorrow]

 * Reverse the new array so that it's sorted from new to old (i.e. [tomorrow, today, yesterday],
 * rendering from top to bottom).
 */ const prepareInstallmentsList = (list)=>list.sort((a, b)=>b.date.localeCompare(a.date, 'en', {
            usage: 'sort',
            numeric: true
        })
    )
;
const Payments = ({ className , subscription  })=>{
    const { getLabel , locale , dateTime  } = useIntl();
    const { Slots: { summary: SummaryTemplate  } ,  } = usePaymentDetailsFormSlots();
    const { installments  } = subscription;
    const LABEL_PREFIX = 'account.ccc.detail.paymentOverview';
    const reversedInstallments = prepareInstallmentsList(installments);
    const getRow = (rowIndex)=>reversedInstallments[rowIndex]
    ;
    const dueDate = subscription.billing.dueDate ? dateTime.formatMidsizeDate(new Date(subscription.billing.dueDate)) : '';
    if (reversedInstallments.length > 0) {
        return /*#__PURE__*/ React.createElement("section", {
            className: classnames('ccc-payments', className)
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "smallest",
            component: "h2"
        }, getLabel('account.ccc.paymentDetails')), SummaryTemplate && /*#__PURE__*/ React.createElement("div", {
            className: "ccc-payments__payment-details"
        }, /*#__PURE__*/ React.createElement(SummaryTemplate, {
            type: subscription.paymentMethod.type,
            values: swcHelpers.objectSpread({}, subscription.paymentMethod.details, {
                dueDate
            })
        })), /*#__PURE__*/ React.createElement(DataTable, {
            "aria-level": 2,
            caption: getLabel(`${LABEL_PREFIX}.title`),
            numberOfRows: reversedInstallments.length
        }, /*#__PURE__*/ React.createElement(DataTable.Col, {
            id: "date",
            header: getLabel('common.date')
        }, (rowIndex)=>/*#__PURE__*/ React.createElement(DateTime, {
                locale: locale,
                dateTime: getRow(rowIndex).date
            })
        ), /*#__PURE__*/ React.createElement(DataTable.Col, {
            id: "provider",
            header: getLabel('common.payment.provider')
        }, (rowIndex)=>{
            const paymentMethodKey = getRow(rowIndex).paymentMethod.toLowerCase().replace(' ', '');
            return getLabel(`common.payment.method.${paymentMethodKey}`);
        }), /*#__PURE__*/ React.createElement(DataTable.Col, {
            id: "amount",
            header: getLabel('common.amount')
        }, (rowIndex)=>/*#__PURE__*/ React.createElement(Price, {
                value: getRow(rowIndex).totalPrice.amount,
                currency: getRow(rowIndex).totalPrice.currency
            })
        ), /*#__PURE__*/ React.createElement(DataTable.Col, {
            id: "status",
            header: getLabel('common.status')
        }, (rowIndex)=>{
            const status = getRow(rowIndex).status.toLowerCase();
            return /*#__PURE__*/ React.createElement("span", {
                className: `status--${status}`
            }, getLabel(`common.status.${status}`));
        })));
    } else {
        console.error(`Payment installments expected for Subscription ID:${subscription.id} but none were found.`);
        return /*#__PURE__*/ React.createElement("section", null, /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            title: `${LABEL_PREFIX}.error`
        }));
    }
};
var Payments$1 = Payments;

export { Payments, Payments$1 as default };
//# sourceMappingURL=Payments.js.map
